<template>
    <div id="secure">
        <Login v-if="$route.path === '/login'"></Login>
        <navbar v-if="$route.path !== '/login'" @logout="logout" :publicSection="true"></navbar>
    </div>
</template>

<script>

import Navbar from '@/components/Navbar.vue';
import Login from '@/views/Login.vue';
import EventBus from '../utils/event-bus';

export default {
  name: 'Public',
  data () {
    return {};
  },
  components: {
    Navbar,
    Login
  },
  methods: {
    logout () {
      EventBus.$emit('logout');
    }
  }
};
</script>

<style scoped>

</style>
